export const BASE_URL = "https://nobel-ai-legal-backend.onrender.com";

// export const BASE_URL = `http://localhost:5000`;
